import { render, staticRenderFns } from "./ResolverDiagnostics.vue?vue&type=template&id=1c5683a7&scoped=true"
import script from "./ResolverDiagnostics.vue?vue&type=script&lang=js"
export * from "./ResolverDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./ResolverDiagnostics.vue?vue&type=style&index=0&id=1c5683a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5683a7",
  null
  
)

export default component.exports